export interface DefaultIconProps {
  /** Stroke/fill color for the icon; typically `WidgetConfig.iconColor`. */
  color: string;
}

/**
 * Small inline feedback/chat-bubble icon bundled with the widget so a host that
 * hasn't uploaded a custom `iconUrl` still gets a sensible default. Deliberately
 * tiny and dependency-free (no external icon font/sprite) to keep the IIFE bundle
 * small — this is the only icon shipped in the widget itself.
 */
export function DefaultIcon({ color }: DefaultIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      // `relative` so this paints above the shape backdrop — see the
      // backdrop's own comment in `Button` for why an unpositioned sibling
      // would not.
      style={{ position: 'relative' }}
    >
      <path
        d="M4 4.5A2.5 2.5 0 0 1 6.5 2h11A2.5 2.5 0 0 1 20 4.5v9a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5v-9Z"
        fill={color}
      />
    </svg>
  );
}
